import { Select, ItemPredicate, ItemRenderer } from "@snpjs/select";
import { Button, Icon } from "@snpjs/core";
import { ISelectProps } from "./ISelectProps";
import React, { useEffect } from "react";

export function DropdownSelect<T>(props: ISelectProps<T>) {
  let items = props.items.map((item, index) => (
    <option key={index + 1} value={index}>
      {props.renderOptionTitle(item)}
    </option>
  ));

  items = [<option key="0">{props.placeholder}</option>, ...items];

  const [selectedItem, setSelectedItem] = React.useState<T | undefined>(props.selected);

  useEffect(() => {
    setSelectedItem(props.selected);
  }, [props.selected]);

  const onSelect = (item: T | undefined) => {
    setSelectedItem(item);
    props.onSelect?.(item);
  };

  const buttonText =
    selectedItem !== undefined
      ? props.renderOptionTitle(selectedItem)
      : props.placeholder || "";

  const itemRenderer: ItemRenderer<T> = (item, { handleClick }) => (
    <div
      onClick={handleClick}
      style={{
        cursor: "pointer",
        padding: "8px",
        transition: "background-color 0.2s",
      }}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f0f0f0")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
    >
      {props.renderOptionTitle(item)}
    </div>
  );

  const itemPredicate: ItemPredicate<T> = (query, item) =>
    props.renderOptionTitle(item).toLowerCase().includes(query.toLowerCase());

  return (
    <Select
      className={props.className}
      filterable={false}
      disabled={props.disabled}
      onItemSelect={(item) => onSelect(item as T)}
      items={props.items}
      itemRenderer={itemRenderer}
      itemPredicate={itemPredicate}
    >
      <Button fill={true} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative' }}>
        <span style={{ position: 'absolute', textAlign: 'center', fontWeight: '500', left: '9px', bottom: '7px'}}>{buttonText}</span>
        <span style={{ position: 'absolute', right: '10px', bottom: '7px' }}><Icon icon="caret-down" /></span>
      </Button>
    </Select>
  );
}
